/**
 * Represents scrollable element
 */
export default class Scrollbar {

    constructor(scrollableElement)
    {
        this.scrollableElement = scrollableElement;
        this.height = undefined;
        this.scrollActive = false;
    }

    /**
     * Enables scrolling on the element.
     *
     * @param {Number} height can also set height right away
     */
    enable(height = undefined)
    {
        this.scrollableElement.css('overflow-y', 'scroll');
        this.scrollableElement.css('touch-action', '');
        this.scrollActive = true;
        if (height) {
            this.setHeight(height);
        }
    }

    /**
     * Disables scrolling on the element.
     */
    disable()
    {
        this.scrollableElement.css('overflow-y', 'hidden');
        this.scrollableElement.css('touch-action', 'none');
        this.scrollActive = false;
    }

    /**
     * Sets the height of a element.
     *
     * @param {Number} height
     */
    setHeight(height)
    {
        this.height = height;
        if (height) {
            this.scrollableElement.css('height', this.height);
        } else {
            this.scrollableElement.css('height', '');
        }
    }

    /**
     * Resets the scroll on scrollable element.
     *
     * @param {Boolean} active what is the default scroll state of a element
     * @param {Number} height
     */
    reset(active = false, height = undefined)
    {
        if (height !== undefined) {
            this.setHeight(height);
        } else {
            this.setHeight(undefined);
        }
        this.scrollableElement.css('overflow-y', '');
        this.scrollableElement.css('touch-action', '');
        this.scrollActive = active;
    }

    /**
     * Returns true if the scoll is active on the element.
     *
     * @returns {Boolean}
     */
    isActive()
    {
        return this.scrollActive;
    }
}
